import React, { useContext } from 'react';
import LiveNavbar from './LiveNavbar';
import { Container } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import MainFooter from '../nav/MainFooter';
import PastEvents from './PastEvents';
import LiveContext from '../../context/liveExperience/liveContext';

const LivePastEvents = () => {
  const liveContext = useContext(LiveContext);

  const { events } = liveContext;
  return (
    <Container className='LivePastEvents p-0' fluid>
      <TopNav />
      <LiveNavbar />
      <Container>
        <div className='live_items'>
          {events.map((event) => (
            <PastEvents key={event.id} event={event} />
          ))}
        </div>
      </Container>
      <MainFooter />
    </Container>
  );
};
export default LivePastEvents;
